import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormConstants } from '../../../core/globals/form-constants';

@Component({
    selector: 'app-field-generator',
    templateUrl: './field-generator.component.html'
})

export class FieldGeneratorComponent {

  @Input() inputControl: FormControl;
  @Input() etsMandate = false;
  @Input() name: string;
  @Input() options: any[];
  @Input() type: string;
  @Input() config: any;
  @Input() showClear = true;
  @Input() savedLocations: any[];
  @Input() city: string;
  @Input() getLocationLabel: (arg0: any) => string;
  @Input() showSavedLocationOnly: boolean;
  @Input() styleApplied: string;
  @Input() selectStyleApplied: string;
  @Input() customStyle: string;
  @Input() maxlength: any;
  @Input() riderOptions: any;
  @Input() showErrorBorder : boolean = true;
  @Input() elementKey:any;
  @Input() costCenterNames:any;
  @Input() departmentListName:any;
  @Input() showCross:boolean;
  @Input() placeholder:string

  @Output() clearFormCallback = new EventEmitter();

  public elementTypes = FormConstants.elementTypes;

  clearFormCallbackFn(event: any) {
    this.clearFormCallback.emit(event);
  }
}
